import { createNode, unpack } from '@splice/elemaudio-core';

// The host's current bpm as a k-rate signal
export function hostBpm(props: { key?: string; fallbackBpm?: number } = {}) {
  return createNode('splice::host_bpm', props, []);
}

// The host's current position in the timeline as a k-rate signal
export function hostPpq(props: { key?: string } = {}) {
  return createNode('splice::host_ppq', props, []);
}

// The host's current playback state as a k-rate signal
export function hostPlaybackState(props: { key?: string } = {}) {
  return createNode('splice::host_playback_state', props, []);
}

// The host's current time signature as a k-rate signal
export function hostTimeSignature(props: { key?: string } = {}) {
  return unpack(
    createNode('splice::host_time_signature', { props, channels: 2 }, []),
    2
  );
}
